import { LETTER_SIZE_TABLE } from '@/constants/letter-size.constants';
import type { ProductSize } from '@onrunning/backstage-models';

function getSizeSortValue(sizeId: string): number {
  const match = /[\d.]+/.exec(sizeId);
  if (match) {
    return Number.parseFloat(match[0]);
  }

  return LETTER_SIZE_TABLE[sizeId] ?? Number.POSITIVE_INFINITY;
}

export function sortProductSizes(sizes: Iterable<ProductSize>): ProductSize[] {
  return [...sizes].sort((sizeA, sizeB) => {
    const sortValueA = getSizeSortValue(sizeA.id);
    const sortValueB = getSizeSortValue(sizeB.id);
    if (sortValueA === sortValueB) {
      return 0;
    }

    return sortValueA - sortValueB;
  });
}
